import {Box, HStack, Image, Text} from '@chakra-ui/react';
import {CheckLoaded} from '@/containers/CheckLoaded';
import {useHalState} from '@synako/haligator';
import {useSocieteCommerciale} from '@/haligator-factory';
import {imageOptimisee} from '@/domains/mediatheque/optimisation';
import {LogoFranceFrais} from '../svg/LogoFranceFrais';
import {Trans, useTranslation} from 'react-i18next';

interface LogosContentProps {
  textFF?: boolean;
  onClick?: () => void;
}

export const LogosContent: React.FC<LogosContentProps> = ({
  textFF = false,
  onClick,
}) => {
  const societeCommerciale = useHalState(useSocieteCommerciale());
  const {t} = useTranslation('common');
  const societeAvecLogo = Boolean(societeCommerciale.data?.url_logo);
  return (
    <HStack
      alignItems='stretch'
      maxHeight='100%'
      cursor='pointer'
      _hover={{opacity: '0.3'}}
      transition='all 0.2s ease'
      onClick={onClick}
    >
      <CheckLoaded
        hook={societeCommerciale}
        render={({data}) => {
          // Sans logo, rien : imageOptimisee renverrait l'image par défaut des articles
          return data.url_logo ? (
            <Image
              src={imageOptimisee(data.url_logo, 96)}
              alt={data.tolede.nom_commercial}
              htmlWidth='464'
              htmlHeight='294'
              maxW='6em'
              objectFit='contain'
              margin='-1'
            />
          ) : null;
        }}
      />
      {/* Logo France Frais : le trait le sépare de celui de la société, s'il y en a un */}
      <Box
        ml={societeAvecLogo ? '3' : undefined}
        pl={societeAvecLogo ? '4' : undefined}
        borderLeft={societeAvecLogo ? '1px solid' : undefined}
        borderColor='blue.main_transparency_60'
        display='flex'
        alignItems='center'
      >
        {textFF && (
          <Text
            fontSize='9px'
            color='blue.main'
            fontWeight='800'
            maxW='78px'
            lineHeight='1.3'
            textAlign='right'
            mx='1'
          >
            <Trans
              t={t}
              i18nKey='branding.slogan'
              components={{br: <br />}}
            />
          </Text>
        )}
        <LogoFranceFrais
          width='4em'
          color='blue.main'
        />
      </Box>
    </HStack>
  );
};
